// Logique pure des écrans des actions sociales (lot L7, M20) : tons des états, montants, motifs honnêtes des
// actes impossibles. Le serveur décide ; ces fonctions n'expliquent que ce que l'écran propose.
import { ETATS_DEMANDE_SOCIALE, type DemandeSociale, type EtatDemandeSociale } from '@cc/contrats';
import type { TonEtat } from '@cc/ui';

export const TON_ETAT_DEMANDE: Record<EtatDemandeSociale, TonEtat> = {
  recue: 'attente',
  en_instruction: 'attente',
  a_decider: 'signer',
  accordee: 'ok',
  refusee: 'retard',
  classee: 'neutre',
  cloturee: 'ok',
};

export const libelleEtat = (e: EtatDemandeSociale) => ETATS_DEMANDE_SOCIALE[e];

/** Montant en francs CFA ; « (fictif) » sur les données de présentation. */
export function montant(n: number | null, fictif = false): string {
  if (n === null) return 'non renseigné';
  return `${n.toLocaleString('fr-FR')} FCFA${fictif ? ' (fictif)' : ''}`;
}

export const effectif = (n: number | null) => (n === null ? 'moins de 5' : String(n));

export interface Droits {
  modifier: boolean;
  transmettre: boolean;
  decider: boolean;
}

/** Motif pour lequel la transmission n'est pas proposée, ou null si elle l'est. */
export function motifTransmissionImpossible(d: DemandeSociale, droits: Droits): string | null {
  if (!droits.transmettre) return 'Votre rôle ne permet pas de transmettre une demande.';
  if (d.etat !== 'recue' && d.etat !== 'en_instruction') return null;
  const evalues = new Set(d.evaluations.map((e) => e.code));
  const manquants = d.criteres.criteres.filter((c) => c.obligatoire && !evalues.has(c.code));
  if (manquants.length > 0)
    return `Évaluer d'abord les critères obligatoires : ${manquants.map((c) => c.libelle).join(', ')}.`;
  if (d.doublons.some((x) => x.examen === 'a_examiner'))
    return "Examiner d'abord les doublons potentiels.";
  return null;
}

/** Motif pour lequel la décision n'est pas proposée à ce compte, ou null. */
export function motifDecisionImpossible(
  d: DemandeSociale,
  droits: Droits,
  moi: string,
): string | null {
  if (d.etat !== 'a_decider') return null;
  if (!droits.decider)
    return 'La décision revient à un compte habilité à décider (responsable social ou maire habilité).';
  if (d.instruction.transmise_par && d.instruction.transmise_par === moi)
    return 'Vous avez transmis cette demande : une autre personne habilitée la décide.';
  return null;
}
